"use client";

/**
 * Global Drawer Stack Context
 * 
 * Provides the context and hook for accessing the global drawer stack.
 * Uses the shared core context factory for consistency with modal stack.
 */

import * as React from "react";
import type { GlobalDrawerStackContextType } from "./types";

export const GlobalDrawerStackContext = React.createContext<GlobalDrawerStackContextType | null>(null);

export const useGlobalDrawerStack = () => {
  const context = React.useContext(GlobalDrawerStackContext);
  if (!context) {
    throw new Error('useGlobalDrawerStack must be used within a GlobalDrawerStackProvider');
  }
  return context;
};
